<template>
  <div>
    <hotel
        v-if="scenicSpot.id"
        :value.sync="scenicSpot"
    >
      <!--    <rooms ref="roomsComp" :rooms="rooms"/>-->
    </hotel>
  </div>
</template>
<script>
import {onMounted, reactive, ref} from 'vue'
import Hotel from './Hotel.vue'
import axios from '../../../request'
import {useRoute} from 'vue-router'
import Rooms from './Rooms'

export default {
  components: {Hotel, Rooms},
  setup() {
    const scenicSpot = reactive({
      name: '',
      pictures: [],
      description: '',
      division: [],
      divisionDetail: '',
      location: ""
    })

    const rooms = reactive([])

    const route = useRoute()

    onMounted(async () => {
      const res = await axios.get(`/hotels/${route.params.id}`)
      scenicSpot.id = res.id
      scenicSpot.name = res.name
      scenicSpot.pictures = res.pictures
      scenicSpot.description = res.description
      scenicSpot.division = res.division.split(',')
      scenicSpot.divisionDetail = res.divisionDetail
      scenicSpot.location = res.location
      // res.rooms.forEach(room => rooms.push(room))
    })

    const roomsComp = ref('')


    // const validateRooms = () => roomsComp.value.validateRooms()
    //
    // const submitRooms = id => roomsComp.value.submitRooms(id)

    return {
      roomsComp,
      // validateRooms,
      // submitRooms,
      scenicSpot,
      rooms
    }
  }
}
</script>
